export enum TWO_COLUMNS_LAYOUT_PROPORTIONS {
  PROPORTION_50_50 = 'proportion_50_50',
  PROPORTION_60_40 = 'proportion_60_40',
}
